import { theme } from "../../theme.js";

export default function Label({label, required=false}) {
    return (
        <label style={styles(theme).label}>
            {label}
            {required && <span style={styles(theme).required}>*</span>}
        </label>
    );
}

const styles = (theme) => ({
label: {
    fontSize: theme.fonts.size.sm,
    fontWeight: theme.fonts.weight.semibold,
    color: theme.colors.textInverted,
    marginBottom: theme.spacing.xs,
  },
required: {
    color: theme.colors.error,
    marginLeft: theme.spacing.xs,
  },
});
